import React, { ReactNode, useEffect, useRef } from 'react';
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import pinkIcon from '../../assets/pink_logo 1.svg';

interface RegistrationLayoutProps {
  children: ReactNode;
}

const RegistrationLayout: React.FC<RegistrationLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const childrenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isSmallScreen && childrenRef.current) {
      childrenRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isSmallScreen]);

  return (
    <Box
      sx={{
        width: isSmallScreen ? '100%' : '70%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack
        direction={isSmallScreen ? 'column' : 'row'}
        spacing={4}
        alignItems="start"
        justifyContent="space-between"
        sx={{ width: '100%', maxWidth: '1200px' }}
      >
        {/* Left column */}
        <Box
          sx={{
            paddingTop: '45px',
            textAlign: 'left',
            width: isSmallScreen ? '100%' : '30%',
            paddingLeft: isSmallScreen ? '20px' : '0',
          }}
        >
          <Box>
            <img src={pinkIcon} alt="pink logo" style={{ width: '50px', height: '50px' }} />
          </Box>
          <Typography variant="h4" fontSize={23} color={'#874B6D'}>{"PinkPOS Admin fiók"}</Typography>
          <Typography variant="h5" sx={{ paddingBottom: '10px' }} fontSize={15} color={'#874B6D'}>{"Minden POS egy helyen"}</Typography>
          <Typography variant="h6" fontSize={12} sx={{ letterSpacing: '1px' }} color={'#504349'}>{"Ügyfeleink gyorsan és kényelmesen irányíthatják az értékesítési folyamatokat egyetlen fiókból, akár több üzletre kiterjedően is."}</Typography>
        </Box>

        {/* Right column */}
        <Box
          ref={childrenRef}
          sx={{
            height: "100vh",
            width: isSmallScreen ? '100%' : '40%', // ~ mobile screen size
            padding: 2,
            backgroundColor: "#FFFFFF"
          }}
        >
          {children}
        </Box>
      </Stack>
    </Box>
  );
};

export default RegistrationLayout;